module.exports = __webpack_public_path__ + "img/85.24caf902.jpg";